import styled from 'styled-components';
import { SemiBoldText, BoldText } from '../Text';
import Colors from 'constants/Colors';
import { Box } from '../Grid';

export const Section = styled.div`

  & + & {
    margin-top: 36px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      display: block;
      width: 100%;
      height: 1px;
      background-color: ${Colors.GRAY[4]};
      transform: translateY(-24px);
      @media (max-width: 992px) {
       position: relative;
      }
    }
  }
`;

export const SectionTitle = styled(SemiBoldText)`
  font-size: 20px;
  color: ${Colors.GRAY[1]};
`;

export const GridColumnTitle = styled(BoldText)`
  font-size: 16px;
  color: ${Colors.GRAY[1]};
`;

export const SectionLegend = styled(BoldText)`
  font-size: 12px;
  color: ${Colors.GRAY[2]};
`;

export const SectionHeader = styled(Box)`
  margin: 0 0 16px;
`;

export const SectionDivider = styled.div`
  height: 1px;
  background-color: ${Colors.GRAY[4]};
`;


